<template>
  <div id="room-details-more">
    <div class="contents">
      <div class="bar-container">
        <div class="bar">
          <div class="ideal" style="width: 20%">
            <div class="nums">
              <div class="start">20%</div>
              <div class="end">35%</div>
            </div>
            <div class="area"></div>
          </div>
          <div class="actual" style="right: 25%">
            <span>18%</span>
          </div>
        </div>
      </div>
      <div class="desc">
        The suggested range is in between 20% and 35%. Your team reached to
        <span>18%</span>.
      </div>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem qui
        dolore fugiat quas earum libero iure et amet! Eius incidunt sed omnis
        neque. Delectus incidunt amet itaque, saepe excepturi sunt.
      </p>
      <h1 class="title">Campaigning & Marketing: <span>10.8%</span></h1>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem qui
        dolore fugiat quas earum libero iure et amet! Eius incidunt sed omnis
        neque. Delectus incidunt amet itaque, saepe excepturi sunt.
      </p>
      <h1 class="title">Campaigning & Marketing: <span>10.8%</span></h1>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem qui
        dolore fugiat quas earum libero iure et amet! Eius incidunt sed omnis
        neque. Delectus incidunt amet itaque, saepe excepturi sunt.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RoomDetailsMore',
  created() {
    this.$parent.setHeader('endominance')
    this.$parent.setBottomTab(false)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" src="../../scss/rooms.scss" scoped></style>
